import type { AxiosRequestConfig } from 'axios'

import { HttpService } from '@/infra/http'

export class PostArquivosDownloadMultiplosService extends HttpService {
  execute = async (urls: string[]) => {
    return this.http.post<Blob, string[], AxiosRequestConfig>(`/api/v2/Arquivos/download-multiplos`, urls, {
      responseType: 'blob',
    })
  }
}
